import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Form, FormInstance } from 'antd';

import { IOfferStore } from 'containers/Offers/Offer/store';

import { getIsNew } from 'utils';

import { OfferDetails } from 'codegen';
import { RecursiveRequired } from 'types';

const { useWatch } = Form;

export const useSetFormValues = (
  form: FormInstance<RecursiveRequired<IOfferStore['initialValues']>>,
  initialValues: IOfferStore['initialValues'],
) => {
  const { offerId } = useParams();
  const isNew = getIsNew(offerId);

  const effectiveFrom = useWatch(['genericValues', 'effectiveFrom'], form);
  const isParticipation = useWatch(['genericValues', 'isParticipation'], form);

  useEffect(() => {
    if (isParticipation && isNew) {
      form.setFields([{
        name: ['genericValues', 'receiptAcceptanceDaysThreshold'],
        value: 0,
      }, {
        name: ['genericValues', 'rewardScope'],
        value: OfferDetails.rewardScope.RECEIPT,
      }, {
        name: ['genericValues', 'maxRedeemsPerCollector'],
        value: 1,
      }]);
    }

    if (!isParticipation && isNew) {
      form.setFields([{
        name: ['genericValues', 'maxRedeemsPerCollector'],
        value: null,
      }]);
    }
  }, [isParticipation]);

  useEffect(() => {
    if (effectiveFrom && isNew) {
      form.setFields([{
        name: ['genericValues', 'displayFrom'],
        value: effectiveFrom,
      }]);
    }
  }, [effectiveFrom]);

  useEffect(() => { form.resetFields(); }, [initialValues]);
};
